import React from 'react'

export default function MergePdf(props) {
  const { className } = props

  return (
    <div className={className ? className : ''}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 32 36"
      >
        <path
          fill="currentColor"
          d="M30.3 8.7v23.2c0 1.8-1.5 3.2-3.2 3.2H5c-1.8 0-3.2-1.5-3.2-3.2v-28C1.8 2.1 3.2.6 5 .6h17.2c.5 0 1.1.2 1.4.6l6.1 6c.3.4.6 1 .6 1.5Z"
          opacity=".1"
        />
        <path
          fill="currentColor"
          d="M30.2 6.8 23.8.6c-.3-.4-.9-.6-1.4-.6h-18C2.6 0 1 1.5 1 3.4v29.2C1 34.5 2.6 36 4.4 36h23.1c1.9 0 3.4-1.5 3.4-3.3V8.5c.1-.7-.2-1.3-.7-1.7Zm-.4 24.9c0 1.7-1.4 3.2-3.1 3.2H5.3c-1.7 0-3.1-1.4-3.1-3.2V4.3c0-1.7 1.4-3.2 3.1-3.2h16.5c.5 0 1 .2 1.4.6l5.9 5.8c.4.4.7 1 .6 1.6v22.6h.1Z"
        />
        <path
          fill="currentColor"
          d="M14.277 6c.291 0 .655.07.947.345v-.001l2.779 2.517.005.006.006.005.04.04a.98.98 0 0 1 .39.794l.053 3.312h3.226c.29 0 .653.07.945.343l2.78 2.519.004.005.006.005.04.038c.295.22.39.535.39.8L26 28.566v.005c0 .384-.193.72-.43.95a1.541 1.541 0 0 1-1.013.407l-10.554.054H14c-.792 0-1.442-.56-1.444-1.352l-.055-5.718-5.941.052h-.004c-.793 0-1.442-.56-1.445-1.353L5 7.254V7.25c0-.135.024-.334.148-.53.11-.172.275-.298.478-.383.277-.222.603-.282.87-.282L14.274 6h.003ZM6.504 7.054H6.5c-.15 0-.224.036-.264.074l-.084.08-.11.036c-.019.006-.032.013-.042.018l.111 14.341v.004c0 .17.127.355.444.356l6.107-.052h.005c.24 0 .46.09.617.26a.826.826 0 0 1 .216.556l.056 5.893v.005c0 .17.126.356.443.356l10.554-.052h.003c.096 0 .248-.06.319-.128.096-.093.125-.185.125-.23l-.111-11.834v-.005l-.001-.013-.034-.022-.035-.034-.055-.053-2.767-2.508-.01-.01c-.04-.038-.115-.074-.264-.074h-3.39a.84.84 0 0 1-.576-.24.817.817 0 0 1-.257-.575l-.056-3.48V9.7l-.034-.02-.035-.034-.056-.054-2.766-2.507-.005-.006-.006-.005c-.04-.038-.115-.074-.265-.074l-7.773.054Z"
        />
        <path
          fill="currentColor"
          d="m14.111 14.91-.667.536-4.11-4.768-.223.161 4.111 4.768-.667.536s.667 0 1.556.268c-.167-.804 0-1.5 0-1.5Zm2.5 6.322.667-.536 4.11 4.768.223-.16-4.111-4.768.667-.536s-.667 0-1.556-.268c.111.857 0 1.5 0 1.5Z"
        />
        <path
          fill="currentColor"
          d="M16.756 19.254c.411.124.771.186 1.026.216a4.53 4.53 0 0 0 .367.03h1.438l-1.107.89-.264.21 4.13 4.79-.442.319-.223.16-.37.27-4.098-4.75-.289.233-1.03.828.224-1.303v-.002l.003-.014.01-.072a5.499 5.499 0 0 0-.016-1.263l-.099-.766.74.224Zm-3.248-4.5.29-.233 1.14-.916-.34 1.422-.004.016-.013.071a3.314 3.314 0 0 0 .02 1.195l.17.823-.805-.243a6.142 6.142 0 0 0-1.026-.216 4.53 4.53 0 0 0-.367-.03h-1.437l1.106-.89.263-.212-4.128-4.787 1.035-.75 4.095 4.75Zm4.104-1.521a.5.5 0 0 1 .887.461l-.221.429a.5.5 0 0 1-.89-.461l.224-.429Z"
        />
        <path
          fill="currentColor"
          d="M13.536 20.465a.5.5 0 1 1 .872.488l-.471.844a.5.5 0 0 1-.873-.489l.472-.843Zm1.889-3.375a.5.5 0 1 1 .873.488l-.945 1.688a.5.5 0 1 1-.873-.489l.945-1.687Zm1.417-2.531a.5.5 0 1 1 .872.488l-.472.844a.5.5 0 0 1-.873-.489l.473-.843Z"
        />
        <path
          fill="currentColor"
          d="M12.723 21.804a.5.5 0 1 1 .887.461l-.221.429a.5.5 0 0 1-.889-.46l.223-.43Z"
        />
      </svg>
    </div>
  )
}
